import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import {
  CalendarDays,
  ChevronLeft,
  ChevronDown,
  ChevronRight,
  LayoutDashboard,
  LogOut,
  Menu,
  Settings,
  Users,
  Wallet,
  X,
  Building2,
  Activity,
  Bell,
  Shield,
  ShieldCheck,
  Briefcase,
  UserCog,
  Tag,
  FileText,
  Layers,
  Calendar,
  Landmark,
  AlertTriangle,
  Award,
  Mail,
  Info,
  CalendarClock,
  ArrowRightCircle,
  DollarSign,
  Receipt,
  Plane,
  ArrowUpCircle,
  ArrowDownCircle,
  Target,
  MessageSquare,
  RefreshCw,
  FileCheck,
  Send,
  Table,
  FileSpreadsheet,
  Download,
  CreditCard,
  BookOpen,
  UserMinus,
  FileSignature,
  BarChart3,
  Upload,
  CreditCard as Payment,
  Gauge,
  Briefcase as Job,
  UserPlus,
  ClipboardList,
  Globe,
  PieChart,
  User,
  CheckCircle,
  Clock,
  Crown,
  Megaphone,
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useFiliale } from '../context/FilialeContext';
import { ROLE_LABELS, getCountryFlag } from '../data/filiales';
import FilialeSwitcher from './FilialeSwitcher';
import PageLoader from './PageLoader';
import http from '../api/http';

const NAV_GROUPS = [
  {
    label: 'Pilotage',
    permission: null,
    items: [{ to: '/dashboard', label: 'Accueil', icon: LayoutDashboard, permission: null }],
  },
  {
    label: 'Ressources humaines',
    permission: 'ressources_humaines',
    items: [
      {
        label: 'Personnel',
        icon: Users,
        permission: null,
        submenu: [
          { to: '/personnel', label: 'Registre du personnel', icon: BookOpen, permission: null },
          { to: '/import-personnel', label: 'Importation employés', icon: Upload, permission: null },
          { to: '/suivi-contrats', label: 'Suivi des contrats', icon: FileSignature, permission: null },
          { to: '/employes-sortis', label: 'Sortie d\'effectif', icon: UserMinus, permission: null },
          { to: '/reporting-rh', label: 'Reporting RH', icon: BarChart3, permission: 'reporting_rh' },
        ]
      },
      {
        label: 'Congés',
        icon: CalendarDays,
        permission: null,
        submenu: [
          { to: '/validation-conges', label: 'Validation', icon: CheckCircle, permission: null },
          { to: '/planning-conges', label: 'Planning RH', icon: Calendar, permission: null },
          { to: '/gestion-soldes-conge', label: 'Gestion des soldes', icon: Wallet, permission: null },
          { to: '/report-annuel', label: 'Report Annuel', icon: RefreshCw, permission: null },
        ]
      },
      {
        label: 'Certificat & Sanctions',
        icon: Award,
        permission: null,
        submenu: [
          { to: '/absences', label: 'Certificats du personnel', icon: Award, permission: null },
          { to: '/personnel-sanctions', label: 'Sanctions du personnel', icon: AlertTriangle, permission: null },
        ]
      },
      {
        label: 'Carrière / Parcours Prof.',
        icon: ArrowRightCircle,
        permission: null,
        submenu: [
          { to: '/mouvements-carriere', label: 'Mouvements carrière', icon: ArrowRightCircle, permission: null },
          { to: '/plans-carriere', label: 'Plans de carrière', icon: Target, permission: null },
          { to: '/succession-planning', label: 'Succession planning', icon: Users, permission: null },
          { to: '/entretiens-carriere', label: 'Entretiens carrière', icon: MessageSquare, permission: null },
          { to: '/demandes-mobilite', label: 'Demandes mobilité', icon: Briefcase, permission: null },
          { to: '/reporting-carriere', label: 'Reporting carrière', icon: BarChart3, permission: null },
        ]
      },
      {
        label: 'Paramétrage RH',
        icon: Settings,
        permission: null,
        submenu: [
          { to: '/departements', label: 'Départements', icon: Building2, permission: null },
          { to: '/titres', label: 'Titres', icon: Award, permission: null },
          { to: '/types-contrat', label: 'Types de contrat', icon: FileSignature, permission: null },
          { to: '/nomenclature-matricule', label: 'Nomenclature matricule', icon: Tag, permission: null },
          { to: '/types-personnel', label: 'Types de personnel', icon: Users, permission: null },
          { to: '/types-conge', label: 'Types de congé', icon: CalendarDays, permission: null },
          { to: '/sanctions', label: 'Types de sanctions', icon: AlertTriangle, permission: null },
        ]
      },
      {
        label: 'Recrutement',
        icon: Job,
        permission: null,
        submenu: [
          { to: '/offres', label: 'Offres', icon: Job, permission: 'offres' },
          { to: '/candidatures', label: 'Candidatures', icon: UserPlus, permission: 'candidatures' },
          { to: '/questionnaires', label: 'Questionnaires', icon: ClipboardList, permission: 'questionnaires' },
          { to: '/portail', label: 'Portail', icon: Globe, permission: 'portail' },
          { to: '/reporting-recrutement', label: 'Reporting', icon: PieChart, permission: 'reporting-recrutement' },
        ]
      },
    ],
  },
  {
    label: 'ESPACE EMPLOYE',
    permission: 'espace_employe',
    items: [
      { to: '/espace-employe', label: 'Mon dossier', icon: User, permission: null },
    ],
  },
  {
    label: 'WORKFORCE MANAGEMENT',
    permission: 'workforce_management',
    items: [
      {
        label: 'Performance',
        icon: BarChart3,
        permission: null,
        submenu: [
          { to: '/import-indicateurs', label: 'Importation indic.', icon: Upload, permission: null },
          { to: '/performance', label: 'Performance', icon: Gauge, permission: null },
          { to: '/indicateurs', label: 'Indicateurs de perf.', icon: Target, permission: null },
          { to: '/activites', label: 'Mode de paiement', icon: Payment, permission: null },
        ]
      },
    ],
  },
  {
    label: 'PAIE',
    permission: 'paie',
    items: [
      {
        label: 'Paie',
        icon: Wallet,
        permission: null,
        submenu: [
          { to: '/periodes-paie', label: 'Périodes de paie', icon: Calendar, permission: null },
          { to: '/elements-paie', label: 'Éléments de paie', icon: DollarSign, permission: null },
          { to: '/exclusions-charges', label: 'Exclusions de charges', icon: Shield, permission: null },
          { to: '/configuration-exoneration', label: 'Exonérations filiale', icon: ShieldCheck, permission: null },
          { to: '/frais-missions', label: 'Frais de missions', icon: Plane, permission: null },
          { to: '/avance-salaire', label: 'Avance sur salaire', icon: ArrowUpCircle, permission: null },
          { to: '/retenue-salaire', label: 'Retenue sur salaire', icon: ArrowDownCircle, permission: null },
          { to: '/regularisation', label: 'Régularisation', icon: RefreshCw, permission: null },
          { to: '/caisse-sociale', label: 'Caisse sociale', icon: Wallet, permission: null },
          { to: '/personnel-stc', label: 'Solde TC', icon: Wallet, permission: null },
          { to: '/export-fiche-paie', label: 'Export/Envoi fiches', icon: Send, permission: null },
          { to: '/grilles-personnel', label: 'Grilles des salaires', icon: Layers, permission: null },
        ]
      },
    ],
  },
  {
    label: 'FINANCE',
    permission: 'finance',
    items: [
      {
        label: 'Reporting',
        icon: Landmark,
        permission: null,
        submenu: [
          { to: '/export-etats', label: 'Exporter les états', icon: Download, permission: null, disabled: false },
        ]
      },
    ],
  },
  {
    label: 'Accès',
    permission: 'acces',
    items: [
      {
        label: 'Gestion des accès',
        icon: Users,
        permission: null,
        submenu: [
          { to: '/users', label: 'Utilisateurs', icon: Users, permission: null },
          { to: '/permissions', label: 'Permissions', icon: Shield, permission: null },
          { to: '/profils', label: 'Profils (Rôles)', icon: Shield, permission: null },
        ]
      },
    ],
  },
  {
    label: 'DIRECTION / PRESIDENCE',
    permission: 'direction_presidence',
    items: [
      {
        label: 'Pilotage',
        icon: Crown,
        permission: null,
        submenu: [
          { to: '/pilotage', label: 'Tableau de bord', icon: Activity, permission: null },
        ]
      },
    ],
  },
  {
    label: 'COMMUNICATION',
    permission: 'communication',
    items: [
      {
        label: 'Communication',
        icon: Megaphone,
        permission: null,
        submenu: [
          { to: '/communication', label: 'Gestion Accueil', icon: Megaphone, permission: null },
        ]
      },
    ],
  },
  {
    label: 'Paramètres',
    permission: 'parametres',
    items: [
      {
        label: 'Paramétrage',
        icon: Settings,
        permission: null,
        submenu: [
          { to: '/filiales', label: 'Filiales', icon: Building2, permission: null },
          { to: '/annees', label: 'Années', icon: Calendar, permission: null },
          { to: '/banques', label: 'Banques', icon: Landmark, permission: null },
          { to: '/sanctions', label: 'Sanctions', icon: AlertTriangle, permission: null },
          { to: '/certificats', label: 'Certificats', icon: Award, permission: null },
          { to: '/mailing', label: 'Mailing', icon: Mail, permission: null },
          { to: '/mises-a-jour', label: 'Mises à jour', icon: Info, permission: null },
          { to: '/clients', label: 'Clients', icon: Briefcase, permission: null },
          { to: '/activites', label: 'Activités', icon: Layers, permission: null },
          { to: '/campagnes', label: 'Campagnes', icon: Target, permission: null },
          { to: '/marques', label: 'Marques', icon: Tag, permission: null },
        ]
      },
      {
        label: 'Logs',
        icon: Activity,
        permission: null,
        submenu: [
          { to: '/logs', label: 'Journal d\'activité', icon: Activity, permission: null },
        ]
      },
    ],
  },
];

const PAGE_TITLES = {
  '/dashboard': 'Accueil',
  '/personnel': 'Personnel',
  '/administration': 'Administration',
  '/users': 'Utilisateurs',
  '/logs': 'Journal d\'activité',
  '/settings': 'Paramètres',
  '/espace-employe': 'Mon dossier',
};

const AdminLayout = () => {
  const { user, hasPermission, logout } = useAuth();
  const { filialeId, currentFiliale, isConsolidated, assignedFiliales } = useFiliale();
  
  // Les super_admin et admin (idprofil=4) voient tous les éléments du menu
  const canAccess = (permission) => {
    if (user?.role === 'super_admin' || user?.role === 'admin') return true;
    if (user?.idprofil === 4) return true;
    if (permission === null) return true;
    return hasPermission(permission);
  };
  
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState({});
  const [currentYear, setCurrentYear] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [nonLues, setNonLues] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    setMobileOpen(false);
    setIsLoading(true);
    const timer = setTimeout(() => setIsLoading(false), 800);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  useEffect(() => {
    localStorage.setItem('rh_sidebar_collapsed', collapsed ? '1' : '0');
  }, [collapsed]);

  useEffect(() => {
    const fetchCurrentYear = async () => {
      try {
        const response = await http.get('/api/annees/current');
        setCurrentYear(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération de l\'année courante:', error);
      }
    };
    fetchCurrentYear();
  }, []);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await http.get('/api/notifications');
        setNotifications(response.data.notifications || []);
        setNonLues(response.data.non_lues || 0);
      } catch (error) {
        console.error('Erreur lors de la récupération des notifications:', error);
      }
    };
    fetchNotifications();
    // Rafraîchir toutes les 30 secondes
    const interval = setInterval(fetchNotifications, 30000);
    return () => clearInterval(interval);
  }, []);

  const pageTitle = PAGE_TITLES[location.pathname] || 'ZEUS SIRH';
  const initials = `${user?.nom?.charAt(0) || ''}${user?.prenom?.charAt(0) || ''}`.toUpperCase() || 'RH';

  const toggleSubmenu = (label) => {
    setOpenSubmenus(prev => {
      // Si on ouvre un sous-menu, fermer tous les autres
      if (!prev[label]) {
        return { [label]: true };
      }
      // Si on ferme le sous-menu, juste le fermer
      return { ...prev, [label]: false };
    });
  };

  const markAsRead = async (id, lien) => {
    try {
      await http.put(`/api/notifications/${id}/lu`);
      setNotifications(prev => prev.map(n => n.id === id ? { ...n, lu: 1 } : n));
      setNonLues(prev => Math.max(0, prev - 1));
      setShowNotifications(false);
      if (lien) {
        navigate(lien);
      }
    } catch (error) {
      console.error('Erreur marquage notification:', error);
    }
  };

  const markAllAsRead = async () => {
    try {
      await http.put('/api/notifications/tout-lu');
      setNotifications(prev => prev.map(n => ({ ...n, lu: 1 })));
      setNonLues(0);
    } catch (error) {
      console.error('Erreur marquage tout lu:', error);
    }
  };

  const formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'À l\'instant';
    if (diffMins < 60) return `Il y a ${diffMins} min`;
    if (diffHours < 24) return `Il y a ${diffHours} h`;
    if (diffDays < 7) return `Il y a ${diffDays} j`;
    return date.toLocaleDateString('fr-FR');
  };

  return (
    <div className="admin-shell">
      <PageLoader isLoading={isLoading} />
      {mobileOpen && (
        <button type="button" className="admin-backdrop lg:hidden" onClick={() => setMobileOpen(false)} aria-label="Fermer le menu" />
      )}

      <aside className={`admin-sidebar ${collapsed ? 'is-collapsed' : ''} ${mobileOpen ? 'is-open' : ''}`}>
        <div className="admin-brand">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-white">
            <img src="/palla.avif" alt="Logo" className="h-7 w-7 object-contain" />
          </div>
          {!collapsed && (
            <div className="min-w-0">
              <p className="truncate text-sm font-semibold text-white">ZEUS SIRH</p>
              <p className="text-[11px] text-slate-400">Console d'administration</p>
            </div>
          )}
          <button type="button" className="ml-auto rounded p-1 text-slate-400 hover:bg-white/10 lg:hidden" onClick={() => setMobileOpen(false)}>
            <X className="h-4 w-4" />
          </button>
        </div>

        <nav className="admin-nav">
          {NAV_GROUPS.map((group) => {
            // Vérifier la permission au niveau du titre du groupe
            if (!canAccess(group.permission)) {
              return null;
            }

            const visibleItems = group.items.filter(item => {
              // Ne pas filtrer les items disabled, ils seront affichés avec le label "Bientôt"
              return canAccess(item.permission);
            });

            // Toujours afficher le groupe, même s'il est vide
            return (
              <div key={group.label} className="admin-nav-group">
                {!collapsed && <p className="admin-nav-label">{group.label}</p>}
                {visibleItems.map((item) => {
                  const Icon = item.icon;
                  const hasSubmenu = item.submenu && item.submenu.length > 0;
                  const isOpen = openSubmenus[item.label];

                  if (item.disabled) {
                    return (
                      <span key={item.to} className="admin-nav-item is-disabled" title={collapsed ? `${item.label} (bientôt)` : undefined}>
                        <Icon className="h-4 w-4 shrink-0" />
                        {!collapsed && (
                          <>
                            <span className="flex-1 truncate">{item.label}</span>
                            <span className="text-[10px] uppercase text-slate-500">Bientôt</span>
                          </>
                        )}
                      </span>
                    );
                  }

                  if (hasSubmenu) {
                    // Afficher tous les sous-éléments sans vérification de permission individuelle
                    return (
                      <div key={item.to || item.label}>
                        <button
                          type="button"
                          onClick={() => toggleSubmenu(item.label)}
                          className="w-full admin-nav-item flex items-center justify-between"
                        >
                          <div className="flex items-center gap-2">
                            <Icon className="h-4 w-4 shrink-0" />
                            {!collapsed && <span className="truncate">{item.label}</span>}
                          </div>
                          {!collapsed && (
                            isOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />
                          )}
                        </button>
                        {isOpen && !collapsed && (
                          <div className="ml-6 mt-1 space-y-1 bg-black rounded-lg p-2">
                            {item.submenu.map((subitem) => {
                              const SubIcon = subitem.icon;
                              return (
                                <NavLink
                                  key={subitem.to}
                                  to={subitem.to}
                                  className={({ isActive }) => `admin-nav-item ${isActive ? 'is-active' : ''}`}
                                >
                                  <SubIcon className="h-4 w-4 shrink-0" />
                                  <span className="truncate">{subitem.label}</span>
                                </NavLink>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  }
                  
                  return (
                    <NavLink
                      key={item.to}
                      to={item.to}
                      title={collapsed ? item.label : undefined}
                      className={({ isActive }) => `admin-nav-item ${isActive ? 'is-active' : ''}`}
                    >
                      <Icon className="h-4 w-4 shrink-0" />
                      {!collapsed && <span className="truncate">{item.label}</span>}
                    </NavLink>
                  );
                })}
              </div>
            );
          })}
        </nav>

        <div className="admin-sidebar-footer">
          <div className="flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-sky-blue text-xs font-semibold text-white">
              {initials}
            </div>
            {!collapsed && (
              <div className="min-w-0">
                <p className="truncate text-sm text-white">{user?.nom} {user?.prenom}</p>
                <p className="truncate text-[11px] text-slate-400">{ROLE_LABELS[user?.role] || user?.role}</p>
              </div>
            )}
          </div>
        </div>
      </aside>

      <div className={`admin-main ${collapsed ? 'is-collapsed' : ''}`}>
        <header className="admin-navbar">
          <div className="flex min-w-0 items-center gap-2">
            <button type="button" className="admin-icon-btn lg:hidden" onClick={() => setMobileOpen(true)} aria-label="Ouvrir le menu">
              <Menu className="h-5 w-5" />
            </button>
            <button
              type="button"
              className="admin-icon-btn hidden lg:inline-flex"
              onClick={() => setCollapsed((value) => !value)}
              aria-label={collapsed ? 'Déplier le menu' : 'Replier le menu'}
            >
              <ChevronLeft className={`h-4 w-4 transition ${collapsed ? 'rotate-180' : ''}`} />
            </button>
            <div className="hidden min-w-0 sm:block">
              <p className="text-[11px] font-medium uppercase tracking-wide text-gray-medium">Console</p>
              <p className="truncate text-sm font-semibold text-night-blue">{pageTitle}</p>
            </div>
          </div>

          <div className="mx-3 min-w-0 flex-1 lg:mx-6 lg:max-w-md">
            <FilialeSwitcher />
          </div>

          <div className="flex items-center gap-2">
            {/* Année courante (exercice en cours) */}
            {currentYear && (
              <div className="hidden md:flex items-center gap-1.5 px-3 py-1.5 bg-blue-900 rounded-lg border border-blue-700">
                <CalendarClock className="h-4 w-4 text-white" />
                <span className="text-xs font-medium text-white">
                  {currentYear.libelle_annee}
                </span>
                {/* Drapeaux */}
                {isConsolidated && assignedFiliales && assignedFiliales.length > 0 ? (
                  <div className="flex items-center gap-1 ml-2">
                    {assignedFiliales.slice(0, 5).map((filiale) => (
                      getCountryFlag(filiale.pays, filiale) && (
                        <img key={filiale.id} src={getCountryFlag(filiale.pays, filiale)} alt={filiale.libelle} className="w-5 h-3 object-cover rounded" title={filiale.libelle} />
                      )
                    ))}
                    {assignedFiliales.length > 5 && (
                      <span className="text-xs text-white/70">+{assignedFiliales.length - 5}</span>
                    )}
                  </div>
                ) : (currentFiliale?.pays || assignedFiliales?.find(f => String(f.id) === String(filialeId))?.pays) && (
                  getCountryFlag(currentFiliale?.pays, currentFiliale) && (
                    <img src={getCountryFlag(currentFiliale?.pays, currentFiliale)} alt={currentFiliale?.libelle} className="w-5 h-3 object-cover rounded ml-2" title={currentFiliale?.libelle} />
                  )
                )}
              </div>
            )}

            {/* Notifications */}
            <div className="relative">
              <button
                type="button"
                onClick={() => setShowNotifications(!showNotifications)}
                className="admin-icon-btn relative"
                title="Notifications"
              >
                <Bell className="h-4 w-4" />
                {nonLues > 0 && (
                  <span className="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white">
                    {nonLues > 9 ? '9+' : nonLues}
                  </span>
                )}
              </button>
              
              {showNotifications && (
                <div className="absolute right-0 top-full z-50 mt-2 w-80 rounded-lg border border-gray-200 bg-white shadow-lg">
                  <div className="border-b border-gray-200 px-4 py-3 flex items-center justify-between">
                    <h3 className="text-sm font-semibold text-night-blue">Notifications</h3>
                    {nonLues > 0 && (
                      <button 
                        onClick={markAllAsRead}
                        className="text-xs text-blue-600 hover:text-blue-800"
                      >
                        Tout marquer comme lu
                      </button>
                    )}
                  </div>
                  <div className="max-h-64 overflow-y-auto">
                    {notifications.length === 0 ? (
                      <div className="px-4 py-8 text-center text-gray-500 text-sm">
                        Aucune notification
                      </div>
                    ) : (
                      notifications.map((notif) => (
                        <div
                          key={notif.id}
                          onClick={() => markAsRead(notif.id, notif.lien)}
                          className={`px-4 py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 ${!notif.lu ? 'bg-blue-50' : ''}`}
                        >
                          <p className="text-sm font-medium text-night-blue">{notif.titre}</p>
                          <p className="text-xs text-gray-medium mt-1">{notif.message}</p>
                          <p className="text-[10px] text-gray-400 mt-1">{formatTimeAgo(notif.created_at)}</p>
                        </div>
                      ))
                    )}
                  </div>
                  <div className="border-t border-gray-200 px-4 py-2">
                    <button
                      onClick={() => {
                        setShowNotifications(false);
                        navigate('/notifications');
                      }}
                      className="text-xs text-blue-600 hover:text-blue-800"
                    >
                      Voir toutes les notifications
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="hidden text-right md:block">
              <p className="text-sm font-medium text-night-blue">{user?.nom} {user?.prenom}</p>
              <p className="text-xs text-gray-medium">{ROLE_LABELS[user?.role] || user?.role}</p>
            </div>
            <button type="button" onClick={() => setShowLogoutConfirm(true)} className="admin-icon-btn" title="Déconnexion">
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        </header>

        <main className="admin-content">
          <Outlet />
        </main>
      </div>

      {/* Logout confirmation modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg">
            <h3 className="text-lg font-semibold text-night-blue mb-2">Confirmer la déconnexion</h3>
            <p className="text-sm text-gray-medium mb-6">Êtes-vous sûr de vouloir vous déconnecter de ZEUS SIRH ?</p>
            <div className="flex justify-end gap-3">
              <button
                type="button"
                onClick={() => setShowLogoutConfirm(false)}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
              >
                Annuler
              </button>
              <button
                type="button"
                onClick={() => {
                  logout();
                  setShowLogoutConfirm(false);
                }}
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
              >
                Se déconnecter
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminLayout;
